import * as echarts from "echarts/core";
import { BarChart, HeatmapChart, LineChart, ScatterChart } from "echarts/charts";
import { AriaComponent, DatasetComponent, DataZoomComponent, GridComponent, LegendComponent, MarkLineComponent, TooltipComponent, VisualMapComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import type { EChartsCoreOption } from "echarts/core";
import { useEffect, useRef } from "react";

echarts.use([AriaComponent, BarChart, CanvasRenderer, DatasetComponent, DataZoomComponent, GridComponent, HeatmapChart, LegendComponent, LineChart, MarkLineComponent, ScatterChart, TooltipComponent, VisualMapComponent]);

interface EChartProps {
  option: EChartsCoreOption;
  label: string;
  height?: number;
  className?: string;
}

export function EChart({ option, label, height = 340, className = "" }: EChartProps) {
  const host = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!host.current) return;
    const chart = echarts.init(host.current, undefined, { renderer: "canvas" });
    chart.setOption({ animationDuration: 450, aria: { enabled: true, decal: { show: true } }, ...option });
    const observer = new ResizeObserver(() => chart.resize());
    observer.observe(host.current);
    return () => {
      observer.disconnect();
      chart.dispose();
    };
  }, [option]);

  return <div ref={host} className={`chart ${className}`} style={{ height }} role="img" aria-label={label} />;
}
